/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Publisher_LabelInputs */

const en_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher / Label`)
};

const es_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial / Sello`)
};

const fr_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur / Label`)
};

const de_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herausgeber / Label`)
};

const ja_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出版社 / レーベル`)
};

const zh_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出版商 / 厂牌`)
};

const ar_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الناشر / شركة الإنتاج`)
};

const id_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penerbit / Label`)
};

const it_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editore / Etichetta`)
};

const ru_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издатель / Лейбл`)
};

const pt_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editora / Selo`)
};

const ko_field_publisher_label = /** @type {(inputs: Field_Publisher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출판사 / 레이블`)
};

/**
* | output |
* | --- |
* | "Publisher / Label" |
*
* @param {Field_Publisher_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_publisher_label = /** @type {((inputs?: Field_Publisher_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Publisher_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_publisher_label(inputs)
	if (locale === "es") return es_field_publisher_label(inputs)
	if (locale === "fr") return fr_field_publisher_label(inputs)
	if (locale === "de") return de_field_publisher_label(inputs)
	if (locale === "ja") return ja_field_publisher_label(inputs)
	if (locale === "zh") return zh_field_publisher_label(inputs)
	if (locale === "ar") return ar_field_publisher_label(inputs)
	if (locale === "id") return id_field_publisher_label(inputs)
	if (locale === "it") return it_field_publisher_label(inputs)
	if (locale === "ru") return ru_field_publisher_label(inputs)
	if (locale === "pt") return pt_field_publisher_label(inputs)
	return ko_field_publisher_label(inputs)
});